<template>
    <el-dialog :visible.sync="isShow" :fullscreen="true" append-to-body :show-close="false">
        <div class="content">
            <video v-show="isVideo" :src="url" controls autoplay></video>
            <img v-show="!isVideo" ref="img" :src="imgUrl" @error="handleImageError" />
            <div class="skip left" :class="{ active: isFirst }" @click="prev">
                <i class="el-icon-arrow-left"></i>
            </div>
            <div class="skip right" :class="{ active: isLast }" @click="next">
                <i class="el-icon-arrow-right"></i>
            </div>
            <div class="close" @click="close">
                <i class="el-icon-close"></i>
            </div>
        </div>
    </el-dialog>
</template>

<script>

export default {
    name: "ImagePreview",
    computed: {
        //文件url
        url() {
            if (this.files.length > 0) return this.files[this.index];
            return "#";
        },
        //图片url
        imgUrl() {
            if (this.url.indexOf(".mp4") > -1) return this.url.replace(".mp4", ".jpg")
            return this.url;
        },
        //是否视频文件
        isVideo() {
            if (this.url.indexOf(".mp4") > -1) return true;
            return false;
        },
        //是否第一张
        isFirst() {
            if (this.index === 0) return true;
        },
        //是否最后一张
        isLast() {
            if (this.index === this.files.length - 1) return true;
        },
    },
    data() {
        return {
            isShow: false,
            index: 0,
            files: [],
        }
    },
    methods: {
        open(files, index) {
            this.isShow = true;
            this.files = [...files];
            this.index = index;
        },
        close() {
            this.isShow = false;
        },
        prev() {
            if (this.index === 0) return;
            this.index--;
        },
        next() {
            if (this.index === this.files.length - 1) return;
            this.index++;
        },        
        handleImageError(event) {
            if (event.target && event.target.src) {
                event.target.src = "/images/img404.png";
                event.target.onerror = null; // 防止循环报错
            }
        }
    }
}
</script>

<style lang="scss" scoped>
// * {
//     border: 1px solid blue;
// }

.content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: black;
}

.content img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.content video {
    width: 100%;
    height: 98%;
}

.close {
    cursor: pointer;

    position: absolute;
    top: 10px;
    right: 16px;

    font-size: 28px;
    color: aliceblue;
    background-color: rgba(232, 14, 14, 0.5);
}

.skip {
    z-index: 10;
    position: absolute;
    top: 50%;

    width: 40px;
    height: 40px;
    border: 1px solid white;
    border-radius: 20px;
    font-size: 32px;
    color: white;

    display: flex;
    justify-content: center;
    align-items: center;

    cursor: pointer;
}

.skip.left {
    left: 10px;
}

.skip.right {
    right: 16px;
}

div i:hover {
    cursor: pointer;
}

//有active类时隐藏箭头
.active {
    display: none;
}
</style>
